import { Checkbox, Label } from "@tellescope/ui";
import { type useEventFormDialogContents } from "../../../../hooks";
import { useTranslation } from "react-i18next";

export interface IntegrationSectionProps extends Pick<ReturnType<typeof useEventFormDialogContents>, "form"> {}

export const IntegrationsSection = ({ form }: IntegrationSectionProps) => {
  const { t } = useTranslation("calendar");

  return (
    <form {...form.getFormProps()} className="space-y-2">
      <span className="flex gap-2 items-center">
        <Checkbox
          id="zoom-integration"
          checked={form.values.zoomIntegration}
          onCheckedChange={(checked) => {
            form.setFieldValue("zoomIntegration", !!checked);
            if (!checked) {
              form.setFieldValue("generateZoomLinkOnCreate", false);
            }
          }}
        />
        <Label htmlFor="zoom-integration" className="text-sm font-light">
          {t("Include Zoom Meeting")}
        </Label>
      </span>
      <span className="flex gap-2 items-center">
        <Checkbox
          id="generate-zoom-link"
          checked={form.values.generateZoomLinkOnCreate}
          onCheckedChange={(checked) => form.setFieldValue("generateZoomLinkOnCreate", !!checked)}
          disabled={!form.values.zoomIntegration}
        />
        <Label htmlFor="generate-zoom-link" className="text-sm font-light">
          {t("Generate Zoom link now")}
        </Label>
      </span>
      <span className="flex gap-2 items-center">
        <Checkbox
          id="auto-sync-healthie"
          checked={form.values.dontAutoSyncPatientToHealthie}
          onCheckedChange={(checked) => form.setFieldValue("dontAutoSyncPatientToHealthie", !!checked)}
        />
        <Label htmlFor="auto-sync-healthie" className="text-sm font-light">
          {t("Don't Auto-sync Patient to Healthie")}
        </Label>
      </span>
    </form>
  );
};
